import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../lib/api';
import { Card, CardHeader, Spinner, ActionButton } from '../components/ui';

/**
 * OAuth landing page. Intuit redirects here (QBO_REDIRECT_URI =
 * <web>/admin/fpa/qbo/callback) with `code` + `realmId` in the query string; we
 * post them to the API to exchange for tokens, then show the result.
 */
export default function AdminFpaQboCallbackPage() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState<'working' | 'done' | 'error'>('working');
  const [msg, setMsg] = useState('Completing the QuickBooks connection…');

  useEffect(() => {
    const code = sp.get('code');
    const realmId = sp.get('realmId') ?? sp.get('realmid');
    if (!code || !realmId) {
      setState('error');
      setMsg('Missing code or realmId in the redirect — start again from QBO mapping → Connect.');
      return;
    }
    api.fpa.qbo.callback(code, realmId)
      .then(() => { setState('done'); setMsg('QuickBooks connected. The next data refresh will pull actuals.'); })
      .catch((e) => { setState('error'); setMsg((e as Error).message); });
    // run once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card>
      <CardHeader><div style={{ fontSize: 13, fontWeight: 500 }}>QuickBooks connection</div></CardHeader>
      <div style={{ padding: 16, fontSize: 13, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {state === 'working'
          ? <Spinner />
          : <div style={{ color: state === 'error' ? 'var(--color-red-text)' : 'var(--color-green-text)' }}>{msg}</div>}
        <div><ActionButton variant="primary" onClick={() => navigate('/admin/fpa/qbo')}>Back to QBO mapping</ActionButton></div>
      </div>
    </Card>
  );
}
